import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../AuthProvider'
import { useFixturesFromQuery } from '../fixtures'

/**
 * Create Prediction ticket embedded in the client portal workspace.
 * Same-origin `/trade/` iframe shares `pp_token` — no second login, no new browser tab.
 */
export function LaunchMt5Page() {
  const { isAuthenticated } = useAuth()
  const fixtures = useFixturesFromQuery()
  const location = useLocation()
  const base = import.meta.env.VITE_TRADE_EMBED_URL || '/trade/?embed=1'
  const tradeSrc = fixtures
    ? `${base}${base.includes('?') ? '&' : '?'}fixtures=1`
    : base

  if (!isAuthenticated && !fixtures) {
    return <Navigate to="/app/login" replace state={{ from: location.pathname }} />
  }

  return (
    <div className="cp-trade-embed">
      <iframe
        className="cp-trade-embed__frame"
        title="Create Prediction"
        src={tradeSrc}
        allow="clipboard-write"
      />
    </div>
  )
}
